import Vue from 'vue';

import 'normalize.css/normalize.css'; // A modern alternative to CSS resets
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss'; // global css

import App from './App';
import store from './store';
import router from './router';
import '@/components/global';

import '@/icons'; // icon
import '@/permission'; // permission control
import * as filters from './filters'; // global filters
import * as directives from '@/directive';
import waves from './directive/waves';
import Comb from './vendor/index';
import globalMixins from '@/mixins/global';

import i18n from './utils/i18n';

import ModalPlugin from '@/components/interactionMethod/modal'
// import uweb from 'vue-uweb';
// import config from './config';
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */
// set ElementUI
// Vue.use(ElementUI);
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) }); // 绑定 i18n 到 Element UI
Vue.use(waves);
Vue.use(Comb);
Vue.use(ModalPlugin)
// Vue.use(uweb, uwebOption);
// register global utility filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
Object.keys(directives).forEach((key) => {
  Vue.directive(key, directives[key]);
});
Vue.config.productionTip = false;

Vue.mixin({
  mixins: [globalMixins],
});
/** 用async包裹目标函数 */
Vue.prototype.awaitWrapper = async function (promise, otherSuccessCode = []) {
  let res;
  try {
    res = await promise;
    const { code, data } = res;
    if (['0', ...otherSuccessCode].includes(code)) {
      return data;
    }
    return null;
  } catch (error) {
    console.error('发生了异常', error);
  }
};

// 防重复点击(指令实现)
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 2000);
      }
    });
  },
});

// 初始化语言为 store 中的值
const savedLang = localStorage.getItem('language');

const lang =
  savedLang ||
  store.state.app.language ||
  'en-US'; // 默认语言（你自己定）

i18n.locale = lang;
store.commit('app/SET_LANGUAGE', lang);

document.documentElement.className =
  i18n.locale === 'zh-CN' || i18n.locale === 'zh-HK' ? 'lang-zh' : 'lang-en';

// 监听 store 变化，更新 i18n.locale
store.watch(
  (state) => state.app.language,
  (newLang) => {
    localStorage.setItem('language', newLang); // ✅ 记录语言
    i18n.locale = newLang;
    window.location.reload();
  }
);

new Vue({
  el: '#app',
  router,
  store,
  i18n, // 将 i18n 挂载到 Vue 实例
  render: (h) => h(App),
});
